import { render, staticRenderFns } from "./CommonAside.vue?vue&type=template&id=2df17d40&scoped=true"
import script from "./CommonAside.vue?vue&type=script&lang=js"
export * from "./CommonAside.vue?vue&type=script&lang=js"
import style0 from "./CommonAside.vue?vue&type=style&index=0&id=2df17d40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df17d40",
  null
  
)

export default component.exports